!<template>
<div>
    <div class="modal fade" role="dialog" id="Modal">
        <div class="modal-dialog modal-md">
            <div class="modal-content">
                <div class="modal-header">
                    <h4 class="modal-title">{{tipo}}</h4>
                </div>
                <form @submit.prevent="accion">
                    <div class="modal-body">
                        <div class="row">
                            <div class="col-md-12">
                                <div class="form-group">
                                    <label>Tipo</label>
                                    <div class="input-group">
                                        <div class="input-group-prepend">
                                            <span class="input-group-addon"><i class="fal fa-tag"></i> </span>
                                        </div>
                                        <select class="custom-select" v-model="tipo_bloqueado">
                                            <option disabled value="">Seleccione</option>
                                            <option value="Email">
                                                Email
                                            </option>
                                            <option value="Dominio">
                                                Dominio
                                            </option>
                                        </select>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-12">
                                <div class="form-group">
                                    <label>Nombre</label>
                                    <div class="input-group">
                                        <div class="input-group-prepend">
                                            <span class="input-group-addon"><i class="fal fa-tag"></i> </span>
                                        </div>
                                        <input class="form-control " placeholder="Nombre" type="text" v-model="nombre">

                                    </div>
                                </div>
                                <span v-if="tipo_bloqueado == 'Dominio'">El dominio debe llevar @</span>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button class="btn-primary btn" type="submit">{{tipo}}</button>
                    </div>
                </form>
            </div>
        </div>
    </div>
</div>
</template>

<script>
export default {
    props: ['tipo', 'nombre'],
    data() {
        return {
            tipo_bloqueado: ""
        }
    },
    mounted() {

    },
    methods: {
        show() {
            console.log("ENTRE");
            $('#Modal').modal('show')
        },
        hide() {
            $('#Modal').modal('hide')
        },
        accion() {
            if (this.nombre == "" || this.nombre == "@") {
                this.$swal.fire({
                    position: 'center',
                    icon: 'error',
                    title: 'Oops...',
                    text: 'Debe llenar el formulario',
                    showConfirmButton: true,
                    timer: 1000,
                });
                return;
            }

            if (!this.verificar_dominio(this.nombre)) {
                this.$swal.fire({
                    position: 'center',
                    icon: 'error',
                    title: 'Oops...',
                    text: 'Verifique el '+ this.tipo_bloqueado,
                    showConfirmButton: true,
                    timer: 1000,
                });
                return;
            }
            this.$emit('accion', this.nombre)
            this.hide()
            this.nombre = "";
        },
        verificar_dominio(valor) {
            if (this.tipo_bloqueado == "Dominio") {
                return valor.match(
                    /^@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
                );
            } else {
                return valor.match(
                    /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
                );

            }

        }
    },
    watch: {
        tipo_bloqueado() {
            if (this.tipo_bloqueado == "Dominio") {
                this.nombre = "@";
            }
        }
    }
}
</script>
